var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ie"},[_c('h1',[_vm._v("Sorry, this Webstore cannot run on Internet Explorer")]),_c('p',[_vm._v("Try Chrome or Firefox.")]),_c('div',{staticClass:"ie-card"})])
}]

export { render, staticRenderFns }